import { register } from '@shopify/theme-sections';

export default register('footer', {
  onLoad() {
    const self = this;

    /**
     * See if there is a region selector.
     */
    const regionSelect = this.container.querySelector('.region-selector__list');

    /**
     * Sanity check.
     */
    if (regionSelect) {
      regionSelect.addEventListener('change', (e) => {
        const value = e.target.value;
        /**
         * Extracts a domain name from a string.
         * https://regexr.com/3au3g
         */
        const DOMAIN_REGEX = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i;
        /**
         * Extracts www. from the start of a string.
         */
        const WWW_REGEX = /^(www.)/;

        /**
         * Try to extract the domain from the select value.
         */
        const domainMatch = value.match(DOMAIN_REGEX);

        /**
         * See if the select value had a valid domain.
         * If so replace www. if it occurs at th start of the URL.
         * If not return null.
         */
        const targetDomain =
          domainMatch === null ? null : domainMatch[0].replace(WWW_REGEX, '');
        const currentDomain = location.hostname;

        /**
         * If the target domain is the same as the current domain, do nothing.
         */
        if (currentDomain === targetDomain) return;

        /**
         * Extract the query parameters from the select value.
         */
        const targetQueryParameters = value.split('?')[1];

        /**
         * Build out a full URL which redirects the user to the target domain, and the current specific path.
         */
        const redirectURL = `${location.protocol}//${targetDomain}${
          location.pathname
        }?${targetQueryParameters}`;

        window.location = redirectURL;
        return;
      });
    }
  },
});
